import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-learners';

const { HeadingGroup, Content, Actions } = Dialog;

export type InviteErrorDialogProps = {
  open: boolean;
  onClose: () => void;
  /** Overrides the generic copy when the caller knows why the submission failed. */
  message?: string;
};

/**
 * Error card for a total failure, with no `failed[]` detail to show. Callers that can name the
 * reason — e.g. a referral approval's error code — pass `message`; the rest get generic copy.
 */
const InviteErrorDialog = ({ open, onClose, message }: InviteErrorDialogProps) => (
  <Dialog open={open} onClose={onClose} width="large">
    <HeadingGroup>{_t('Something went wrong')}</HeadingGroup>
    <Content>
      <Typography2 component="p">{message ?? _t("We couldn't send invitations. Please try again.")}</Typography2>
    </Content>
    <Actions>
      <Button variant="primary" onClick={onClose}>
        {_t('Done')}
      </Button>
    </Actions>
  </Dialog>
);

export default InviteErrorDialog;
